<div
  class="sonder-modal-backdrop"
  [ngClass]="{'backdrop-see-through': !hasBackdrop}"
  aria-hidden="true"
  (click)="staticBackdrop || closeSonderModal()"
  data-test="sonder-modal-backdrop"
></div>
<div 
  id="sonder-modal"
  [ngClass]="[
    'sonder-modal',
    modalSizeClass,
    isMobile ? 'mobile' : ''
  ]"
  [nativeAppClass]
  aria-modal="true"
  role="dialog"
  #modalDivToFocusTrap
>
  <div class="sonder-modal-header">
    <div class="actions-left">
      <ng-content select=".header-actions-left"></ng-content>
    </div>

    <div class="actions-right" data-test="subscription-settings-close-icon-x">
      <ng-content select=".header-actions-right"></ng-content>
      <iris-icon-button
        (click)="closeSonderModal(true)"
        icon="close"
        ariaLabel="close dialog"
        [type]="IrisIconButtonTypes.TERTIARY"
        class="sonder-modal-close"
        data-test="sonder-modal-close-icon"
    ></iris-icon-button>
    </div>
  </div>

  <div class="sonder-modal-content">
    <ng-content></ng-content>
  </div>

  <ng-content select=".sonder-modal-footer"></ng-content>
</div>
